export enum MountingMaterial {
  STANDARD_FEET = 'STANDARD_FEET',
  ANTI_VIBRATION_FEET = 'ANTI_VIBRATION_FEET',
  WALL_MOUNT = 'WALL_MOUNT',
  SNOW_FEET = 'SNOW_FEET'
}
